<template>
    <v-tab-item :value="LIST.value">
        <!-- <div class="tab-wrap">
            <private-sale-categories :value="group" v-bind="{ categories }" />
            <v-expand-transition>
                <private-sale-categories v-show="children" :value="group" :categories="children || []" withoutAll />
            </v-expand-transition>
        </div> -->
        
        <div class="tab-wrap">
            <auction-program-search v-bind="{ totalCount }" onlySearch />
        </div>

        <div class="tab-wrap">
            <auction-category-select :value="category" v-bind="{ categories }" returnObject @input="(category) => $router.push(`/private-sales/${LIST.value}/groups/${category?.code || 'all'}`)" cols="6" sm="4" md="3" />
        </div>

        <auction-work-list :works="works" class="gallery-card-row" />
        <div class="v-pagination-wrap">
            <v-pagination :value="page" :length="pageCount" :total-visible="11" class="mt-8 mb-16" @input="(page) => $router.push({ query: { ...this.$route.query, page } })" />
        </div>

        <v-fade-transition leave-absolute>
            <v-overlay v-show="loading" color="white" light>
                <v-progress-circular color="primary" indeterminate size="100" width="5" />
            </v-overlay>
        </v-fade-transition>
    </v-tab-item>
</template>

<script>
import api from "@/api";
import { mapActions } from "vuex";
import { AUCTION_CATEGORY_GROUPS, PRIVATE_SALES_TABS, WORK_AUCTION_MODES } from "@/assets/variables";

import AuctionProgramSearch from "@/components/client/auction/programs/auction-program-search.vue";
import AuctionCategorySelect from "@/components/client/auction/categories/auction-category-select.vue";
import AuctionWorkList from "../auction/auction-work-list.vue";
import PrivateSaleCategories from "./private-sale-categories.vue";

const { LIST } = PRIVATE_SALES_TABS;

export default {
    components: {
        AuctionProgramSearch,
        AuctionCategorySelect,
        AuctionWorkList,
        PrivateSaleCategories,
    },
    data: () => ({
        searchKeys: [
            { text: "전체", value: null },
            { text: "test", value: "test" },
        ],
        LIST,
        loading: false,

        works: [],

        totalCount: 0,
        limit: 20,
    }),
    computed: {
        categories() {
            return this.$store.state.categories.filter(({ group }) => group == AUCTION_CATEGORY_GROUPS.PRIVATE.value);
        },
        group() {
            return this.$route.params.group || "all";
        },
        sort() {
            return this.$route.query.sort || "lot_desc";
        },
        searchKey() {
            return this.$route.query.searchKey || null;
        },
        searchValue() {
            return this.$route.query.searchValue || null;
        },
        page() {
            return +this.$route.query.page || 1;
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.totalCount / this.limit) || 1;
        },
        headers() {
            const { skip, limit } = this;
            return { skip, limit };
        },
        category() {
            return this.getCategory(this.group);
        },
        children() {
            if (this.category?.depth == 1) return this.category?.children;
            else return this.categories.find(({ _id }) => _id == this.category?._parents?.[0])?.children;
        },
        params() {
            const { category, sort, searchKey, searchValue } = this;

            const params = { mode_auction: WORK_AUCTION_MODES.PRIVATE.value, _category: category?._id, sort, searchKey, searchValue };

            if (!params._category) delete params._category;

            return params;
        },
        isOn() {
            return /^\/private-sales\/LIST/.test(this.$route.path);
        },
    },
    mounted() {
        this.getCategories();
        this.init();
    },
    watch: {
        params() {
            this.init();
        },
    },
    methods: {
        ...mapActions(["getCategories"]),
        init() {
            if (!this.isOn) return;
            this.works = [];
            this.totalCount = 0;

            this.search();

            let path = `/private-sales/${PRIVATE_SALES_TABS.LIST.value}/groups/${this.group}`;
            if (this.$route.path != path) this.$router.replace({ path, query: this.$route.query });
        },
        async search() {
            if (!this.isOn) return;
            if (this.loading) return;
            else this.loading = true;
            try {
                const { headers, params } = this;
                var {
                    summary: { totalCount },
                    works,
                } = await api.v1.auction.works.gets({ headers, params });

                this.works = works;
                this.totalCount = totalCount;
            } finally {
                this.loading = false;
            }
        },
        getCategory(code, categories = this.categories) {
            const category = categories.find((item) => item.code == code);
            if (category) return category;

            const children = categories.flatMap(({ children }) => children);
            if (children.length) return this.getCategory(code, children);

            return null;
        },
    },
};
</script>

<style></style>
